import { database, subscribeToPath } from './database';
import { AccessRecord } from '../types';

const COLLECTION = 'accessRecords';

export const accessService = {
    getAll: (callback: (records: AccessRecord[]) => void, onError?: (error: any) => void) => {
        return subscribeToPath(COLLECTION, (data) => {
            const records = data ? Object.values(data) as AccessRecord[] : [];
            callback(records.sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || '')));
        }, onError);
    },

    create: async (record: Omit<AccessRecord, 'id' | 'createdAt' | 'updatedAt'>) => {
        return await database.createAccessRecord(record);
    },

    update: async (id: string, updates: Partial<Omit<AccessRecord, 'id' | 'createdAt'>>) => {
        await database.updateAccessRecord(id, updates);
    },

    delete: async (id: string) => {
        await database.deleteAccessRecord(id);
    }
};
